import React, { useContext, useState } from 'react'
import { createPortal } from 'react-dom'
import { QuoteDialog } from './quoteDialog'
import { ProjectContext } from '@/context/ProjectContext'
import thumbnailDefault from '@/assets/audio-thumbnail.png'
import PropTypes from 'prop-types'
import { Quote } from './quote'

export function Quotes() {
  const { quotes, sessions } = useContext(ProjectContext)
  const starredQuotes = quotes.filter((quote) => quote.star)
  if (!starredQuotes.length) return null
  const [currentQuote, setCurrentQuote] = useState(-1)
  const [visibleQuotes, setVisibleQuotes] = useState(5)

  // Handle loading more quotes
  const loadMoreQuotes = () => {
    setVisibleQuotes((prev) => prev + 5)
  }

  return (
    <div className="pb-[28px] border-b border-[#e4e4e4]">
      <p className="text-[#3f424a] text-[22px] font-bold font-['DM_Sans'] leading-relaxed">Key Quotes</p>
      <p className="mb-[16px] text-[#62708d] text-base font-medium font-['Manrope'] leading-[23px]">
        Here are some key segments from the conversation.
      </p>

      <div className="flex flex-col">
        <div className="flex flex-col gap-4 overflow-hidden w-[400px]">
          {starredQuotes.slice(0, visibleQuotes).map((quote, index) => (
            <Quote key={quote.id} quote={quote} index={index} setCurrentQuote={setCurrentQuote} />
          ))}
        </div>

        {visibleQuotes < starredQuotes.length && (
          <button
            className="mt-4 py-2 px-4 bg-blue-600 rounded-md w-full bg-[#E6E6E6] text-zinc"
            onClick={loadMoreQuotes}
          >
            Load More Quotes
          </button>
        )}
      </div>

      {currentQuote >= 0 &&
        createPortal(
          <QuoteDialog
            meet={sessions.find((session) => session.id === starredQuotes[currentQuote]?.meetingId)}
            quote={starredQuotes[currentQuote]}
            currentQuote={currentQuote}
            totalQuotes={starredQuotes.length}
            thumbnail={
              starredQuotes[currentQuote]?.thumbnailUrl ||
              sessions.find((session) => session.id === starredQuotes[currentQuote]?.meetingId)?.thumbnailUrl ||
              thumbnailDefault
            }
            next={currentQuote > 0 ? () => setCurrentQuote((prev) => prev - 1) : null}
            prev={currentQuote < starredQuotes.length - 1 ? () => setCurrentQuote((prev) => prev + 1) : null}
            closeDialog={() => setCurrentQuote(-1)}
          />,
          document.body
        )}
    </div>
  )
}

Quotes.propTypes = {
  label: PropTypes.string,
  quotes: PropTypes.array,
}
